import { UserType } from 'api/minside/models/UserType';

export const formatUserType = (
  enumValue: UserType,
  externalUserText: string | undefined = undefined,
  internalUserText: string | undefined = undefined
) => (enumValue === UserType.External ? externalUserText ?? 'Ekstern bruker' : internalUserText ?? 'Intern bruker');
